function ZoomInIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      fill='none'
      viewBox='0 0 24 25'
      className='viewer-icon'
    >
      <g fill='#06F' clipPath='url(#clip0_3036_4428)'>
        <path d='M23.28 20.42l-3.36-3.36c1.08-1.68 1.68-3.6 1.68-5.76 0-6-4.8-10.8-10.8-10.8C4.8.5 0 5.3 0 11.3c0 6 4.8 10.8 10.8 10.8 2.16 0 4.08-.6 5.76-1.68l3.36 3.36c.96.96 2.4.96 3.36 0s.96-2.4 0-3.36zM10.8 19.7c-4.68 0-8.4-3.72-8.4-8.4s3.72-8.4 8.4-8.4 8.4 3.72 8.4 8.4-3.84 8.4-8.4 8.4z' />
        <path d='M15.6 10.1H12V6.5c0-.72-.48-1.2-1.2-1.2s-1.2.6-1.2 1.2v3.6H6c-.6 0-1.2.48-1.2 1.2s.48 1.2 1.2 1.2h3.6v3.6c0 .72.48 1.2 1.2 1.2s1.2-.48 1.2-1.2v-3.6h3.6c.72 0 1.2-.48 1.2-1.2s-.6-1.2-1.2-1.2z' />
      </g>
      <defs>
        <clipPath id='clip0_3036_4428'>
          <path fill='#fff' d='M0 0H24V24H0z' transform='translate(0 .5)' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ZoomInIcon;
